export default class CreateCampaignOpportunitiesRequest {
    opportunityIds: string[] = [];
}
